// ----------------------------------------------------------------------
// <copyright file="Izenda.Dimensions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var Measure = require('share/components/controls/Izenda.Measure');

  var observable = require('mobx').observable;
  var action = require('mobx').action;
  var observer = require('mobx-react').observer;
  const { omit } = require('lodash/fp');
  function Dimensions(ComposedComponent) {
    var DimensionsComponent = React.createClass({
      displayName: String.format('Dimensions({0})', ComposedComponent.displayName),
      componentWillMount: function() {
        this.dim = observable({
          width: 0,
          height: 0
        });
      },
      render: function() {
        var measureBeforeMount = this.props.measureBeforeMount;
        var rest = omit(['measureBeforeMount'], this.props);
        var width = this.dim.width;
        var height = this.dim.height;

        return (
          <Measure measureBeforeMount={measureBeforeMount} onChange={this.onChange}>
            <ComposedComponent {...rest} width={width} height={height} />
          </Measure>
        );
      },
      onChange: action(function changeDimension(width, height) {
        this.dim.width = width;
        this.dim.height = height;
      })
    });

    return observer(DimensionsComponent);
  }

  module.exports = Dimensions;
})();



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.Dimensions.jsx